/**
 * Define dark or light style on page load.
 */
window.addEventListener('load', function() {
    const isProductTemplate = document.body.classList.contains('template-product');

    if (document.querySelector('.dark-first-section')) {
        document.querySelector('.site-header').classList.add('light-header');
    } else {
        document.querySelector('.site-header').classList.add('light-header-bg');
        if (!isProductTemplate) {
            document.getElementById('MainContent').style.paddingTop = '8rem';
        }
    }

    if (document.querySelector('.piled-up-first-section')) {
        document.getElementById('MainContent').style.paddingTop = '5.6rem';
    }
});

( function( $ ) {
	let burger_btn = $('.js_header-burger-nav #burger-btn');

	/**
	 * Header product modals.
	 */
	$('.site-header .modal').appendTo('.site-header .js__header-modals-container');

	/**
	 * Scrolling style.
	 */
	let isScrolled = false;
	$(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
			isScrolled = true;
			if( !$('.site-header').hasClass('scrolled') ) {
				$('.site-header').addClass('scrolled');
			}
        } else {
			isScrolled = false;
			// Only remove scrolled class if header is not hovered
			if( !$('.site-header').hasClass('hovered') && $('.site-header').hasClass('scrolled') ) {
				$('.site-header').removeClass('scrolled');
			}
        }
    });

	/**
	 * Header container hover style (desktop only).
	 * Changes color only, no retraction (retraction only happens on scroll).
	 */
	$('.js_header-container').on('mouseenter', function() {
		// Add hovered class for color change only
		if( !$('.site-header').hasClass('hovered') ) {
			$('.site-header').addClass('hovered');
		}
	}).on('mouseleave', function() {
		// Only remove hovered class if not actually scrolled
		if( !isScrolled && $('.site-header').hasClass('hovered') ) {
			$('.site-header').removeClass('hovered');
		}
	});

	/**
	 * SEARCH BAR
	 */
	let searchBtn = $('.js__search-btn');
	let searchBar = $('.js__search-bar');
	searchBtn.on('click', function() {
		searchBtn.toggleClass('active');
		searchBar.toggleClass('active');
	});

	$(document).on("click", function (event) {
		if (!$(event.target).closest(searchBar).length && !$(event.target).closest(searchBtn).length) {
			searchBtn.removeClass('active');
			searchBar.removeClass('active');
		}
	});

	/**
	 * MEGA MENU
	 */
	$('.mega-menu-list .menu_first-item').on('click', function() {
		let $this = $(this);
		if( $this.hasClass('active') ) {
			$this.removeClass('active');
			$this.find('.menu_first-item_chevron').css("transform", "rotate(0deg)");
			// Menu: First level items
			$('.site-header').removeClass('active-submenu');
			// Menu: Mega menu items
			$this.closest('.mega-menu-list').find('.mega-menu-wrapper').removeClass('active');
		} else {
			$this.addClass('active');
			$this.find('.menu_first-item_chevron').css("transform", "rotate(180deg)");
			$('.mega-menu-list .menu_first-item_chevron').not($this.find('.menu_first-item_chevron')).css("transform", "rotate(0deg)");
			$('.mega-menu-list .menu_first-item').not($this).removeClass('active');
			// Menu: First level items
			if( !$('.site-header').hasClass('scrolled') ) {	
				$('.site-header').addClass('active-submenu');
			}
			// Menu: Mega menu items
			$('.mega-menu-wrapper').not($this.closest('.mega-menu-list').find('.mega-menu-wrapper')).removeClass('active');
			$this.closest('.mega-menu-list').find('.mega-menu-wrapper').addClass('active');
		}
	});

	// Close mega menu when clicking outside
	$(document).on("click", function (event) {
		if (!$(event.target).closest(".site-header").length) {
			$('.mega-menu-list .menu_first-item').removeClass('active');
			$('.mega-menu-list .menu_first-item_chevron').css("transform", "rotate(0deg)");
			$('.site-header').removeClass('active-submenu');
			$('.mega-menu-wrapper').removeClass('active');
		}
	});

	// Close mega menu on window resize
	$(window).on('resize', function () {
		$('.mega-menu-list .menu_first-item').removeClass('active');
		$('.mega-menu-list .menu_first-item_chevron').css("transform", "rotate(0deg)");
		$('.site-header').removeClass('active-submenu');
		$('.mega-menu-wrapper').removeClass('active');
		searchBtn.removeClass('active');
		searchBar.removeClass('active');
	});

	/**
	 * Navigation style.
	 */
	let header_container = $('.js_header-container');
	let header_nav_items_width = $('.js_header-nav-items').outerWidth() + 30;
	let header_max_width = header_container.width() - $('#header-logo').width();
	
	// On windoww load.
	if ( header_nav_items_width > header_max_width ) {
		mobile_navigation();
	} else {
		desktop_navigation();
	}
	
	// On window resize.
	$(window).on('resize', function () {
		header_max_width = header_container.width() - $('#header-logo').width();

		if ( header_nav_items_width > header_max_width ) {
			mobile_navigation();
		} else {
			desktop_navigation();
			// Close burger menu.
			burger_btn.removeClass('active');
			$('header-drawer').addClass('-translate-x-[25rem]').removeClass('translate-x-0');
		}
	});

	/**
	 * BURGER MENU
	 */
	// Open burger menu.
	burger_btn.on('click', function() {
		let $this = $(this);
		if( $this.hasClass('active') ) {
			$this.removeClass('active');
			$('header-drawer').addClass('-translate-x-[25rem]').removeClass('translate-x-0');
		} else {
			$this.addClass('active');
			$('header-drawer').addClass('translate-x-0').removeClass('-translate-x-[25rem]');
		}
	});
	// Close burger menu.
	$('.js_burger-close-btn').on('click', function() {
		burger_btn.removeClass('active');
		$('header-drawer').addClass('-translate-x-[25rem]').removeClass('translate-x-0');
	})
	// Burger parent menu items.
	$('.js_burger-parent-item button').on('click', function() {
		let $this = $(this);
		if( $this.hasClass('active') ) {
			$this.removeClass('active');
			$this.find('span').css("transform", "rotate(0deg)");
			$this.closest('.js_burger-parent-item').find('.js_burger-children-items').addClass('hidden').removeClass('flex');
		} else {
			$this.addClass('active');
			$this.find('span').css("transform", "rotate(180deg)");
			$this.closest('.js_burger-parent-item').find('.js_burger-children-items').addClass('flex').removeClass('hidden');
			// Close other menus.
			$('.js_burger-parent-item button').not($this).removeClass('active');
			$('.js_burger-children-items').not($this.closest('.js_burger-parent-item').find('.js_burger-children-items')).addClass('hidden').removeClass('flex');
		}
	});

	/**
	 * Functions
	 */
	function desktop_navigation() {
		$('.js_header-nav-items').addClass('flex').removeClass('hidden');
		$('.js_header-burger-nav').addClass('hidden').removeClass('flex');
	}
	function mobile_navigation() {
		$('.js_header-nav-items').addClass('hidden').removeClass('flex');
		$('.js_header-burger-nav').addClass('flex').removeClass('hidden');
	}
})( jQuery );